import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import 'components/LoginForm/LoginForm.scss'
import { HttpService } from 'services/HttpService';
import CircleLoader from 'components/CircleLoader/CircleLoader';
import MessageBox from 'components/MessageBox/MessageBox';

export class ChangePasswordForm extends Component {

  messageBox = {
    title: "Login Failed",
    message: "Check your Email and enter the verification code to reset your Password.",
    color: "danger",
    icon: "error"
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.passwordChange = this.passwordChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onPasswordRepeatChange = this.onPasswordRepeatChange.bind(this);
    this.onMessageClose = this.onMessageClose.bind(this);
    this.state = {
      password: '',
      passwordRepeat: '',
      loaderIsActive: false,
      showMessageBox: false
    };
  }

  passwordChange() {
    this.setState({loaderIsActive: true, showMessageBox: false })

    const host = process.env.REACT_APP_SERVER;
    const body = {
      "email": this.state.email,
      "code": this.state.code,
      "newpassword": this.state.password
    };
    new HttpService().sendRequest(`${host}/api/users/passwordChange`, {
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((result) => {

      this.setState({ showMessageBox: true });
      this.messageBox.message = result.response;

      if (result.res) {
        this.messageBox.title = 'Request Successful';
        this.messageBox.color = 'primary';
        this.props.onSubmit({ result: 'success' });
      } else {
        this.messageBox.title = 'Request Failed';
        this.messageBox.color = 'danger';
      }

      this.setState({ loaderIsActive: false });
    })
    .catch((err) => {
      console.log(err)
    })
  }

  componentDidMount() {
    this.setState({ email: this.props.email, code: this.props.code });
  }

  onPasswordRepeatChange(password) {
    this.setState({passwordRepeat: password})
  }

  onPasswordChange(password) {
    this.setState({password: password})
  }

  onMessageClose(event) {
    this.setState({ showMessageBox: false });
  }

  handleSubmit(event) {
    const { password, passwordRepeat } = this.state;

    if (password !== passwordRepeat) {
      this.setState({ showMessageBox: true });
      this.messageBox.title = "Failed"
      this.messageBox.message = 'Passwords don\'t match';
      this.messageBox.color = 'danger';
    } else {
      this.passwordChange();
    }

    event.preventDefault();
  }

  render() {
    const { loaderIsActive, showMessageBox } = this.state;

    return (
      <form className="o-login-form" onSubmit={this.handleSubmit}>
        <h1 className="o-login-form__title">Change your password</h1>
        <p className="o-login-form__subtitle">Choose a new password for your account.</p>

        <div className="o-login-form__field">
          <label className="o-login-form__label" htmlFor="change-password">New Password</label>
          <div className="o-login-form__input-box">
            <i className="material-icons">lock_outline</i>
            <input
              id="change-password"
              className="o-login-form__input"
              type="password"
              autoComplete="new-password"
              placeholder="Enter a new password"
              onChange={(event) => this.onPasswordChange(event.target.value)}
              required
            />
          </div>
        </div>

        <div className="o-login-form__field">
          <label className="o-login-form__label" htmlFor="change-password-confirm">Confirm Password</label>
          <div className="o-login-form__input-box">
            <i className="material-icons">lock_outline</i>
            <input
              id="change-password-confirm"
              className="o-login-form__input"
              type="password"
              autoComplete="new-password"
              placeholder="Re-enter the new password"
              onChange={(event) => this.onPasswordRepeatChange(event.target.value)}
              required
            />
          </div>
        </div>

        {
          !loaderIsActive ?
          <button className="o-login-form__submit" type="submit" value="Submit">
            <span>Change password</span>
          </button>
          : <CircleLoader isActive={loaderIsActive} />
        }

        <div className="o-login-form__signup">
          <span>Remembered it?</span>
          <Link to="/login">
            Back to log in
            <i className="material-icons">arrow_forward</i>
          </Link>
        </div>

        {
          showMessageBox ?
          <MessageBox {...this.messageBox} onClose={this.onMessageClose} />
          : ''
        }
      </form>
    )
  }
}

export default ChangePasswordForm
